import { useState, useEffect } from "react"
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import DataTable from '../../../components/data-table/DataTable'
import BasicCard from "../../../components/basics/cards/BasicCard";
import LocalScenarioAddEdit from './LocalScenarioAddEdit'
import { ScenarioAPIService } from "../../../services/apis/ScenarioAPIService"

function ScenarioListing({ scenarioSelection, setScenarioSelection, isLoading, error, filterArray }) {
    const [showAddEdit, setShowAddEdit] = useState(false)
    const [selectedScenario, setSelectedScenario] = useState({})

    const initialState = {
        scenario: {
            scenarioId: '',
            scenarioCode: '',
            scenarioName: '',
            scenarioTypeId: 2,
            sortIndex: 0,
            memo: '',
            tagetikCurrencyBucket: 1,
            defaultCurrencyId: 1,
            mappingTypeId: 1,
            isDeleted: false,
            lastUpdateDate: '',
        },
        scenarios: [],
    };

    const [state, setState] = useState(initialState);
    
    // CONSTANTS
    const tableConfig = {
        tableData: scenarioSelection.map(scenario => {
            return {
                scenarioCode: scenario.scenarioCode,
                name: scenario.scenarioName,
                scenarioType: scenario.scenarioType,
                percentageType: scenario.percentageType,
                tagetikCurrencyBucket: scenario.currencyBucket
            }
        }),
        tableColumns: ['Name', 'Scenario type', 'Percentage type', 'Tagetik currency bucket'],
        tableColumnIds: ['name', 'scenarioType', 'percentageType', 'tagetikCurrencyBucket'],
        rowId: 'scenarioCode',
        hasHoverEffect: 'true',
        handleRowClick: async (scenarioCode) => {
            ScenarioAPIService.getScenarioByScenarioCode(scenarioCode).then(scenarioData => {            
                var scenario = {
                    scenarioId: scenarioData.scenarioId,
                    scenarioCode: scenarioData.scenarioCode,
                    scenarioName: scenarioData.scenarioName,
                    scenarioTypeId: scenarioData.scenarioTypeId,
                    memo: scenarioData.memo,
                    tagetikCurrencyBucket: scenarioData.currencyBucketId,
                    defaultCurrencyId: scenarioData.defaultCurrencyId,
                    mappingTypeId: scenarioData.mappingTypeId,
                    sortIndex: scenarioData.sortIndex,
                    isDeleted: scenarioData.isDeleted,
                    nodes: scenarioData.nodes,
                    lastUpdateDate: scenarioData.lastUpdateDate
                };
                setState(values => ({ ...values, scenario: scenario }));
                setShowAddEdit(true);
            })
        }
    }

    // EVENT HANDLERS
    const handleCreateNewNode = () => {       
        var scenario = {
            scenarioId: '',
            scenarioCode: '',
            scenarioName: '',
            scenarioTypeId: 2,
            sortIndex: '',
            memo: '',
            tagetikCurrencyBucket: 1,
            defaultCurrencyId: 1,
            mappingTypeId: 1,
            isDeleted: false,
            lastUpdateDate: '',
        };
        setState(values => ({ ...values, scenario: scenario }));
        setShowAddEdit(true);
    }

    return (
        <Container fluid className='basic-listing-container'>
            <Row md={1} lg={2}>
                <Col fluid lg={showAddEdit ? 6 : 10}>
                    <BasicCard cardConfig={{ cardTitle: 'Scenarios', cardHeadingElement: 'h4' }}>
                        {isLoading ? <p>Loading data ...</p> : ""}
                        {error ? <p style={{ color: 'red' }}>{error}</p> : ""}
                        {scenarioSelection?.length > 0 ?
                            <div className='listing-table-wrapper'>
                                <DataTable tableConfig={tableConfig} setState={setState} />
                            </div>
                            : ""
                        }
                        <Button variant='primary' onClick={handleCreateNewNode} className='listing-add-button'>+</Button>
                    </BasicCard>                                        
                </Col>
                {showAddEdit && (
                    <Col>
                        <LocalScenarioAddEdit scenarioSelection={scenarioSelection} setScenarioSelection={setScenarioSelection} setShowAddEdit={setShowAddEdit} state={state} setState={setState} selectedScenario={selectedScenario} filterArray={filterArray} />
                    </Col>
                )}
            </Row>           
        </Container>
    )
}

export default ScenarioListing